import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from "@angular/forms";
import { TmFilterInputSelectorComponent } from "../../shared/ui/filter-input-selector/filter-input-selector.component";
import { OrganisationalUnit } from "@teammood/shared/util/core";

@Component({
    selector: 'org-unit-name-table-cell',
    templateUrl: './org-unit-name-table-cell.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    FormsModule,
    TmFilterInputSelectorComponent
]
})
export class OrgUnitNameTableCell implements OnInit {
    updatedOrgUnit: OrganisationalUnit;

    @Input() availableOrgUnitNames: string[];
    @Input() orgUnit: OrganisationalUnit;

    @Output() orgUnitUpdateEvent : EventEmitter<OrganisationalUnit> = new EventEmitter();

    constructor() {}

    ngOnInit() {
        this.updatedOrgUnit = undefined;
        this.updatedOrgUnit = {...this.orgUnit};
        this.updatedOrgUnit.name = '';
    }    

    onOrgUpdated = (orgName: string) => {
        this.updatedOrgUnit.name = orgName;
    }

    save = async (orgUnit: OrganisationalUnit)=> {
        this.orgUnitUpdateEvent.emit(orgUnit);    
    }

    cancel = () => {
        this.orgUnitUpdateEvent.emit(null);    
    }
}